<template>
  <div class="footer-area-wrapper" :class="FooterStyle">
    <div class="footer-area section-space--ptb_90">
      <div class="container">
        <div class="row footer-widget-wrapper">
          <div class="col-lg-4 col-md-6 footer-widget">
            <div class="footer-widget__logo mb-30">
              <router-link to="/">
                <img
                  src="../../assets/img/logo/logo.png"
                  class="img-fluid logo-dark"
                  alt="logo"
                />
                <img
                  src="../../assets/img/logo/cyber-light.png"
                  class="img-fluid logo-light"
                  alt="logo"
                />
              </router-link>
            </div>
            <ul class="footer-widget__list">
              <li>
                我們可提供各類訂製科技方案，包括網頁製作、手機應用程式開發等服務，助您的企業升級，領先行頭。
              </li>
            </ul>
          </div>
          <div class="col-lg-2 col-md-6 footer-widget offset-lg-2">
            <h5 class="footer-widget__title mb-20">燊煥有限公司</h5>
            <ul class="footer-widget__list">
              <li>
                <a href="#about" class="hover-style-link">關於我們</a>
              </li>
              <li>
                <a href="#service" class="hover-style-link">我們的服務</a>
              </li>
              <li>
                <a href="mailto:info@cyberfire.com.hk" class="hover-style-link"
                  >聯絡我們</a
                >
              </li>
            </ul>
          </div>
          <div class="col-lg-4 col-md-6 footer-widget">
            <h5 class="footer-widget__title mb-20">我們的資訊</h5>
            <ul class="footer-widget__list">
              <li>荔枝角青山道688-690號嘉名工廠大廈D座7樓18室</li>
              <li>
                <a href="mailto:info@cyberfire.com.hk" class="hover-style-link"
                  >info@cyberfire.com.hk</a
                >
              </li>
              <li>
                <a href="tel:+85259008417" class="hover-style-link"
                  >+852 5900 8417</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="footer-copyright-area border-top section-space--ptb_30">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-12 text-center">
            <span class="copyright-text mb-0">
              &copy; {{ new Date().getFullYear() }}
              <a href=""><b class="hover-style-link">CyberFire</b></a
              >. All rights reserved.
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FooterMain",
  props: ["FooterStyle"],
};
</script>

<style scoped>
.bg_drak-footer {
  background: #2e3280;
  border-top: 3px solid #5556ca;
}

.hover-style-link:hover {
  color: #ffffff;
}
</style>
